import type { StatusBadgeProps } from "@h2j-data-team/ui";
import type { SyncStatus } from "@repo/shared";

/** The StatusBadge tone of each sync status. */
export const SYNC_TONE: Record<SyncStatus, NonNullable<StatusBadgeProps["tone"]>> = {
  in_sync: "success",
  out_of_sync: "warning",
  missing: "danger",
  unknown: "neutral",
};

/** The `sync-groups` i18n key suffix of a sync status (`syncStatus.<key>`). */
export function statusKey(status: SyncStatus): "inSync" | "outOfSync" | "missing" | "unknown" {
  switch (status) {
    case "in_sync":
      return "inSync";
    case "out_of_sync":
      return "outOfSync";
    case "missing":
      return "missing";
    default:
      return "unknown";
  }
}
